export default function newsletterFormInit(){
    const repeaterAddBtn = document.querySelector('.newsletter-repeater .elementor-repeater-add');
    if(!repeaterAddBtn) return;
    repeaterAddBtn.textContent = 'Aggiungi un\'altra macchina';
}